import { render, staticRenderFns } from "./CarouselComponent.vue?vue&type=template&id=14fdc874&scoped=true&"
import script from "./CarouselComponent.vue?vue&type=script&lang=js&"
export * from "./CarouselComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fdc874",
  null
  
)

export default component.exports